// Company information
export const COMPANY_NAME = 'sivonte';
export const COPYRIGHT = `\u00A9 ${COMPANY_NAME} ${new Date().getFullYear()}`;

// Contact information
export const CONTACT_EMAIL = 'krzysztof.talar@protonmail.com';
export const GITHUB_URL = 'https://github.com/krzysztoftalar';
export const LINKEDIN_URL = 'https://www.linkedin.com/in/ktalar';

// Theme
export const THEME_KEY = 'theme';
export const DARK_THEME_KEY = 'dark';
export const LIGHT_THEME_KEY = 'light';
